/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { ActivityLog } from './../models/activity-log.model';
import { ApiResponse } from '@core/models';
import { ApiService } from '@core/services';
import { AcitivityLogType } from '@core/enums';

@Injectable({ providedIn: 'root' })
export class ActivityLogService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  getActivityLogForClient(clientId: number): Observable<ApiResponse<ActivityLog[]>> {
    return this.http.get<ApiResponse<ActivityLog[]>>(`${this.apiService.superAdminApi}/activity-log/${clientId}`);
  }

  createActivityLog<T1, T2>(
    clientId: number,
    oldValue: T1,
    newValue: T2,
    type: AcitivityLogType,
    subType: string
  ): Observable<ApiResponse<ActivityLog>> {
    return this.http.post<ApiResponse<ActivityLog>>(`${this.apiService.superAdminApi}/activity-log/${clientId}`, {
      oldValue,
      newValue,
      type,
      subType,
    });
  }
}
